/*Author - Subhalakshmi S
Date - 18-10-2024
Task - UI/UX:blog */
import React from "react";
import axiosInstance from "../axiosConfig";

class SiteSettingsService extends React.Component {
  getSiteDetails = async () => {
    return await axiosInstance.get(`/api/get-site-settings`);
  };

  updateContact = async (payload) => {
    return await axiosInstance.post(`/api/update-contact`,payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };

  updateILS = async (payload) => {
    return await axiosInstance.post(`/api/update-ils`,payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
  //08-04-2025 - support email - Subha
  updateSupport = async (payload) => {
    return await axiosInstance.post(`/api/update-support`,payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
  //11-04-2025 - terms and condition - Subha
  updateTerms = async (payload) => {
    return await axiosInstance.post(`/api/update-terms-condition`,payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
  updateNewUserEmail = async (payload) => {
    return await axiosInstance.post(`/api/update-new-user-email`,payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
}

const instance = new SiteSettingsService();

export default instance;
